export default __webpack_public_path__ + "static/media/Stalker's Arm-straps of the Battlethrall.c609204d.jpg";